import { useEffect } from 'react'
import { isMobilePlatform, isTelegramVersionSupported } from './useTelegram'

let isInitialized = false

export const useTelegramInit = () => {
  useEffect(() => {
    if (!isInitialized) {
      const tg = window.Telegram.WebApp
      tg.ready()
      tg.expand()

      if (isTelegramVersionSupported(6.1)) {
        tg.disableVerticalSwipes()

        // Enable fullscreen mode only on mobile devices
        if (isMobilePlatform()) {
          tg.requestFullscreen()
          tg.lockOrientation()
        }
      }

      isInitialized = true
    }
  }, [])
}
